export default __webpack_public_path__ + "static/barry-chat-background-dark-10b096c96e89639aac012c6e2bc56a7f.png";